import React from "react";
import { Document, Page, Text, View, StyleSheet, PDFViewer, PDFDownloadLink, Font, Image  } from '@react-pdf/renderer';
import Prompt from "../assets/fonts/Sarabun/Prompt-Bold.ttf";
import { colors } from "../configs";

const { white } = colors;

Font.register(
  {
    family: "Prompt",
    src: Prompt,
  }
);

function LargeVerticalNoPro({
    data
}) {

  return    <Document style={{ fontFamily: "Prompt", fontSize:13  }} >
                {data.map((item,index)=>{
                    const { name, unit, price, barcode, barcodeImage } = item;
                    return <Page size="A4" key={index}  >
                            <View style={{width:"100%",alignItems:'center', borderWidth:0.5, flex:1}} >
                                <View style={{backgroundColor:'#de2702', width:'100%', justifyContent:'center', alignItems:'center', paddingLeft:10, paddingRight:10, color:white, height:250 }} >
                                    <Text style={{ fontSize:55, marginTop:-50 }}  >{name}</Text>
                                </View>
                                <View style={{ flex:1 }} >
                                  <Text style={{ fontSize:170, marginTop:-40, marginBottom:-40, justifyContent:'center' }} >{price}</Text>
                                  {/* <Text style={{ fontSize:290, marginTop:-40, marginBottom:-40 }} >{price}</Text> */}

                                </View>
                                <View style={{flexDirection:'row',alignItems:'flex-end', marginTop:-5, justifyContent:'space-around', width:'100%', marginBottom:70 }} >
                                    <Text style={{ fontSize:35 }}>({unit})</Text>
                                    <Text style={{ fontSize:50 }}>บาท</Text>
                                </View>
                                <Text style={{ fontSize:20 }} >{barcode}</Text>
                                {barcodeImage && <Image style={{ width:'500px'}} src={barcodeImage} />}
                            </View>
                        </Page>
                })}

                </Document>
}

export default LargeVerticalNoPro;
